var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApprovedDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.575l-2.79 2.789-1.21-1.218a.5.5 0 10-.707.708l1.571 1.571a.5.5 0 00.707 0l3.144-3.143a.5.5 0 10-.707-.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 14.5a6.006 6.006 0 00-5-5.91V6a.5.5 0 00-.146-.354l-4-4A.5.5 0 0017 1.5H5a.5.5 0 00-.5.5v2.5H2a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-2.5H21a.5.5 0 00.5-.5v-2.59a6.006 6.006 0 005-5.91zm-9-11.293L19.793 5.5H17.5zm1 22.293h-16v-20h2V23a.5.5 0 00.5.5h13.5zm2-3h-15v-20h11V6a.5.5 0 00.5.5h3.5v2a6 6 0 000 12zm0-3a5 5 0 115-5 5.006 5.006 0 01-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.646L8.952 15.2l-.6-.6a.5.5 0 00-.708.707l.953.952a.5.5 0 00.707 0l1.905-1.9a.5.5 0 00-.707-.708zM10.5 17.646L8.952 19.2l-.6-.6a.5.5 0 00-.708.707l.953.952a.5.5 0 00.707 0l1.905-1.9a.5.5 0 00-.707-.708zM8 5.5h6a.5.5 0 000-1H8a.5.5 0 000 1zM14 7.5H8a.5.5 0 000 1h6a.5.5 0 000-1zM11 10.5H8a.5.5 0 000 1h3a.5.5 0 000-1z"
  }))));
}

export default SvgApprovedDocument;